/* unplugin-vue-components disabled */
import {downloadFile, get_file} from 'stores/files'
import Docfile from './docfile.vue'
import Audio from './audio.vue'
import FileSkeleton from './file-skeleton.vue'
import Restricted from './restricted.vue'
import $profile from 'stores/profile'

export default {
  components: {Restricted, Docfile, Audio, FileSkeleton},
  props: {
    id: {
      type: String,
      required: true,
    },
    restricted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      file: undefined,
    }
  },
  computed: {
    ext(){
      return this.file?.ext
    },
    can_share(){
      return !!navigator.canShare && this.ext === 'mp3'
    }
  },
  async mounted() {
    if (this.restricted) return
    try {
      this.file = await get_file(this.id)
    }
    catch(err) {
      console.log(err)
    }
  },
  methods: {
    async share(){
      const response = await fetch(this.file.url)
      const blob = await response.blob()
      const file = new File([blob], this.file.name, {type: blob.type})
      try {
        if (navigator.canShare({files: [file]})) {
          await navigator.share({
            title: `${$profile.display_name} shared this Genrate.ai file with you`,
            text: 'Materials prepared for your use.',
            files: [file]
          })
        } else {
          $utils.toasts.error('Can\'t share this type of file')
        }
      } catch (error) {
        if (error.name === 'AbortError') return
        throw error
      }
    },
    downloadFile() {
      if (this.file) {
        downloadFile(this.id)
      }
    }
  }
}
